"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCursorAction = exports.StyledHeaderContainer = exports.StyledSectionWrapper = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
exports.StyledSectionWrapper = components_core_1.styled.div `
  width: 100%;
  margin-bottom: 70px;
`;
exports.StyledHeaderContainer = components_core_1.styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: solid 1px #dfe4e8;
  & > :first-child {
    margin-right: 60px;
  }

  @media (min-width: ${components_core_1.Breakpoints.b1280}px) {
    justify-content: flex-start;
    margin-bottom: 25px;
  }
`;
exports.StyledCursorAction = components_core_1.styled.div `
  cursor: pointer;
`;
